export enum MessageType {
  Annotation = "annotation",
  Clear = "clear",
  Undo = "undo",
  RequestPoints = "request-points",
  SendPoints = "send-points",
  Color = "color",
  Active = "active",
  MouseUpdate = "mouse-update",
}

export interface Point {
  x: number
  y: number
}

export interface Drawing {
  points: Point[][]
  color: string
  userMouse: Point | null
}

export interface PointBuffer {
  points: Point[]
  startIndex: number
  lineIndex: number
}

export interface AnnotationMessage {
  sender: string
  type: MessageType
  target?: string
  points?: Point[]
  drawing?: Drawing
  color?: string
  lineIndex?: number
  startIndex?: number
  x?: number
  y?: number
  active?: boolean
  url?: any
}
